import {Euler, Vector3, Scene} from "three";

const FLOOR_NUMBER = {
    BOTTOM_FLOOR: 1,
    TOP_FLOOR: 2,
};
// Here we split by Artists Names
//ChatRoom01
//ScreenStageLeft
const CameraLocationsDB = [
    {
        cameraLocationId: 'RD',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: 'The Royal Derby Hospital',
        displayMesh: 'N',
        // cameraPosition: new Vector3(6.459, -1, .408),
        // cameraRotation: new Euler(0, 1.249, 0, 'XYZ'),
        // offset3D: new Vector3(0,1.25,0), // type Vector3 - offsets the camera by adding Vector3 to the position -  applies only on locations set in Blender. Default is Vector3(0,0,0) see also clientOption.CAMERA_LOCATION_OFFSET
        // cameraLocationOffset: 3, //type float overrides  the global clientOption.CAMERA_LOCATION_OFFSET
        cameraLocationLevel2Id: ['RDL1', 'RDL2', 'RDH1','RDH2'],
    },
    {
        cameraLocationId: 'RDL1',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: 'Level #1',
        cameraLocationIdOfChild: 'Y',
        cameraPosition: null,
        cameraRotation: null,
        displayMesh: 'N',
    },
    {
        cameraLocationId: 'RDL2',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: 'Level #2',
        cameraLocationIdOfChild: 'Y',
        cameraPosition: null,
        cameraRotation: null,
        displayMesh: 'N',
    },
  /*  {
        cameraLocationId: 'RDH',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: 'Royal Derby Hospital',
        // cameraPosition: new Vector3(6.459, -1, .408),
        // cameraRotation: new Euler(0, 1.249, 0, 'XYZ'),
        // offset3D: new Vector3(0,1.25,0), // type Vector3 - offsets the camera by adding Vector3 to the position -  applies only on locations set in Blender. Default is Vector3(0,0,0) see also clientOption.CAMERA_LOCATION_OFFSET
        // cameraLocationOffset: 3, //type float overrides  the global clientOption.CAMERA_LOCATION_OFFSET
        cameraLocationLevel2Id: ['RDH1', 'RDH2'],
    },*/
    {
        cameraLocationId: 'RDH1',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: 'Level #3',
        cameraLocationIdOfChild: 'Y',
        cameraPosition: null,
        cameraRotation: null,
        displayMesh: 'N',
    },
    {
        cameraLocationId: 'RDH2',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: 'Level #4',
        cameraLocationIdOfChild: 'Y',
        cameraPosition: null,
        cameraRotation: null,
        displayMesh: 'N',
    },
    {
        cameraLocationId: 'LRCH',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: 'London Road Community Hospital',
        displayMesh: 'N',
        // cameraPosition: new Vector3(6.459, -1, .408),
        // cameraRotation: new Euler(0, 1.249, 0, 'XYZ'),
        // offset3D: new Vector3(0,1.25,0), // type Vector3 - offsets the camera by adding Vector3 to the position -  applies only on locations set in Blender. Default is Vector3(0,0,0) see also clientOption.CAMERA_LOCATION_OFFSET
        // cameraLocationOffset: 3, //type float overrides  the global clientOption.CAMERA_LOCATION_OFFSET
        cameraLocationLevel2Id: ['LRCH1']
    },
    {
        cameraLocationId: 'LRCH1',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: 'Level #3',
        cameraLocationIdOfChild: 'Y',
        cameraPosition: null,
        cameraRotation: null,
        displayMesh: 'N',
    },

];

export {CameraLocationsDB, FLOOR_NUMBER};
